
import Component from "vue-class-component"
import BeneficiaryNominationChart from "@/superannuation/BeneficiaryNominationChart.vue"
import MetricTrendWidget from "@/superannuation/MetricTrendWidget.vue"
import PercentOutlineWidget from "@/components/dashboard/PercentOutlineWidget.vue"
import CircularProgressWidget from "@/components/dashboard/CircularProgressWidget.vue"
import IconBannerWidget from "@/components/dashboard/IconBannerWidget.vue"
import SuperScoreProgressWidget from "@/components/dashboard/SuperScoreProgressWidget.vue"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import {MetricStore} from "@/cube/metric-data/MetricStore"
import DetailPage from "@/superannuation/DetailPage.vue"
import AccountBalanceChart from "@/superannuation/AccountBalanceChart.vue"
import {WithAnalyticsNavigation} from "@/superannuation/WithAnalyticsNavigation"
import {CampaignService} from "@/CampaignService"

@Component({
  components: {
    DetailPage,
    ChangeRateWidget,
    SuperScoreProgressWidget,
    IconBannerWidget,
    CircularProgressWidget,
    PercentOutlineWidget,
    BeneficiaryNominationChart,
    MetricTrendWidget,
    AccountBalanceChart,
  },
})
export default class AccountBalanceView extends WithAnalyticsNavigation {
  metricStore: MetricStore

  created() {
    this.metricStore = new MetricStore()
  }

  async onSelectViewChange(url: string) {
    await this.$router.push(`/super/${url}`)
  }

  get contactRequests() {
    return this.metricStore.get(this.$metrics.ContactRequested.countRequests, {
      [this.$cubes.ContactRequestedCube.reason]: "accountBalance",
    })
  }

  get campaigns() {
    return this.metricStore.get(this.$metrics.Campaign.runs, {
      [this.$cubes.CampaignCube.campaignType]: CampaignService.CAMPAIGN_TYPE_REPORT,
    })
  }
}
